<script>
  import AmpelBoxVersionEins from "./AmpelBoxVersionEins.svelte";
  import LineBarMixedChart from "./LineBarMixedChart.svelte";
  import { create_target_line, get_labels, get_last_available_value, transform_month_data_last_value } from "./SixModulesUtils.svelte";
  import { object_values } from "./Utils.svelte";

  export let redraw;
  export let year = 2090;
  export let target_start = 10;
  export let target_end = 60;
  export let include_vorjahr;
  export let month_data = {
    "2020-01": 20,
    "2020-02": 35,
    "2020-03": 40,
    "2020-04": 50,
    "2020-05": 70,
    "2020-06": 75,
    "2020-07": 40,
    "2020-08": 10,
    // '2020-09': 10,
    // '2020-10': 10,
    // '2020-11': 10,
  };

  //TODO Letzter Eintrag in Array entfernen wenn er Null ist(?)

  export let month_data_vorjahr = {
    "2020-01": 10,
    "2020-02": 15,
    "2020-03": 10,
    "2020-04": 15,
    "2020-05": 10,
    "2020-06": 10,
    "2020-07": 20,
    "2020-08": 10,
    // '2020-09': 10,
    // '2020-10': 10,
    // '2020-11': 10,
  };

  export let time_modus = "monthly";

  let data = {
    labels: ["Jan", "Feb", "Mar", "Apr"],
    datasets: [
      {
        label: "Dataset 1",
        data: [25, 35, 45, 55],
        type: "line",
        borderColor: "#4eb3cf",
        pointRadius: 0,
      },
      {
        label: "Dataset 2",
        data: [20, 30, 35, 50],
        type: "line",
        borderColor: "#afcb08",
        pointRadius: 0,
      },
      {
        label: "Dataset 3",
        data: [20, 30, 35, 50],
        type: "bar",
        borderColor: "#afcb08",
        pointRadius: 0,
      },
      {
        label: "Dataset 4",
        data: [15, 20, 30, 45],
        type: "bar",
        borderColor: "#d9d9d9",
        pointRadius: 0,
      },
    ],
  };

  $: {
    target_start, target_end, month_data, time_modus, include_vorjahr;
    if (month_data && time_modus) {
      data = {
        labels: get_labels(year, time_modus),
        datasets: [
          {
            label: "Target",
            data: create_target_line(time_modus, month_data, target_start, target_end, "active_boli", true),
            type: "line",
            borderColor: "#00B0F0",
            pointRadius: time_modus != "biannual" ? 0 : 5,
            pointStyle: time_modus != "biannual" ? "circle" : "triangle",
          },
          time_modus != "biannual"
            ? {
                label: "Active Boluses dontshow",
                data: transform_month_data_last_value(object_values(month_data), time_modus),
                type: "line",
                borderColor: "#afcb08",
                pointRadius: 0,
              }
            : {},
          include_vorjahr
            ? {
                label: "Previous Year",
                data: transform_month_data_last_value(object_values(month_data_vorjahr), time_modus),
                type: "bar",
                borderColor: "#d9d9d9",
                pointRadius: 0,
              }
            : {},
          {
            label: "Active Boluses",
            data: transform_month_data_last_value(object_values(month_data), time_modus),
            type: "bar",
            borderColor: "#afcb08",
            pointRadius: 0,
          },
        ],
      };

      redraw = false;
      redraw = true;
    }
  }
</script>

<AmpelBoxVersionEins
  target={target_end}
  current_target={create_target_line(time_modus, month_data, target_start, target_end, "active_boli", true)[
    object_values(month_data).length - 1
  ]}
  current={get_last_available_value(object_values(month_data))}
  unterer_text={"Active boluses " +
    Object.keys(month_data)[Object.keys(month_data).length - 1].substring(5, 7) +
    "/" +
    (year - 2000).toString()}
/>

<div class="row" style="width:100%; margin: 0px;">
  <div class="col" style="max-width:10px!important;"><div class="vertical-center rotate" /></div>
  <div class="col" style="margin:0px; padding:0px; height:0px;">
    <LineBarMixedChart
      id={Math.floor(Math.random() * 1000000)}
      line_data={data}
      barPercentage={0.9}
      categoryPercentage={time_modus == "monthly" ? 0.9 : 0.3}
      type={"bar"}
      k={true}
      bind:redraw
    />
  </div>
</div>

<style>
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .rotate {
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    transform: rotate(-90deg);
  }
</style>
